






















































































































































import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { state } from "./data/state";
import Vue from "vue";

export default Vue.extend({
  components: { DropDownSimple },
  setup() {
    const {
      event_types,
      selected_event_type,
      set_selected_event_type,
      toggle_show_pending_list,
      show_pending_list,
      severities,
      set_severity,
      selected_severity,
      applications,
      selected_application,
      set_application,
      admins,
      selected_admin,
      set_selected_admin,
    } = state;
    return {
      event_types,
      selected_event_type,
      set_selected_event_type,
      toggle_show_pending_list,
      show_pending_list,
      severities,
      set_severity,
      selected_severity,
      applications,
      selected_application,
      set_application,
      admins,
      selected_admin,
      set_selected_admin,
      justification_page_desc: `<ul class="list-disc p-6">
      <li class="text-light text-lg mb-2">
        Explore both <i><b>Pending</b></i> and <i><b>Completed</b></i> event
        queries by toggling the top left tabs.
      </li>
      <li class="text-light text-lg mb-2">
        <i><b>Pending</b></i> justifications are emails that have been sent and
        not yet received and answer.
      </li>
      <li class="text-light text-lg">
        <i><b>Completed</b></i> justifications are emails that have received an
        answer. Review the answer in the <i><b>Response</b></i> column
      </li>
    </ul> `,
    };
  },
});
